<template>
  <g>
    <path
      d="M5.55555 11.3889V8.05561C5.55555 5.60769 7.55208 3.61117 10 3.61117C12.4479 3.61117 14.4444 5.60769 14.4444 8.05561V11.3889H5.55555ZM20 13.0556C20 12.1355 19.2535 11.3889 18.3333 11.3889H17.7778V8.05561C17.7778 3.78478 14.2708 0.277832 10 0.277832C5.72917 0.277832 2.22222 3.78478 2.22222 8.05561V11.3889H1.66667C0.746528 11.3889 0 12.1355 0 13.0556V23.0556C0 23.9757 0.746528 24.7223 1.66667 24.7223H18.3333C19.2535 24.7223 20 23.9757 20 23.0556V13.0556Z"
    />
  </g>
</template>
